import { CmsCard } from '../../components/cms/CmsCard';
import { fullUrlWithRecipe } from '../utility/ImageRecipeUtil';
import { ActionMethod, AssetType, CmsProperty } from '../../api/models/Shared.types';
import { ScheduleExtractor } from './ScheduleExtractor';
import { Backend } from '../../api/Backend';
import { IAssetAction, IRibbon2Asset } from '../../api/models/AndromeTV.types';
import { CardSizeInfo } from './CardSizeInfo';
import { ChannelModel } from '../../api/EpgApi.types';
import { Recording } from '../../api/user/RecordingApi.types';

export class CardDataSource {
  backend: Backend;
  asset: IRibbon2Asset;
  sizeInfo: CardSizeInfo;
  pageProperties: string[];
  channels: ChannelModel[];
  private action: IAssetAction;
  nrOfRecordings: number;
  recording: Recording | undefined;
  constructor(
    backend: Backend,
    asset: IRibbon2Asset,
    sizeInfo: CardSizeInfo,
    pageProperties: string[] = [],
    channels: ChannelModel[] = [],
    action?: IAssetAction
  ) {
    this.backend = backend;
    this.asset = asset;
    this.sizeInfo = sizeInfo;
    this.pageProperties = pageProperties;
    this.channels = channels;
    this.action = action || this._getAction();
    this.nrOfRecordings = 0;
  }

  loadRecording(programId: string, channelId: string) {
    return this.backend.cachedRecordingsApi.recordingForProgram(this.backend, programId, channelId).then(recording => {
      this.recording = recording;
    });
  }

  componentDescription() {
    return {
      focusable: true,
      type: CmsCard,
      data: this,
      w: this.sizeInfo.width,
      h: this.sizeInfo.height,
    };
  }

  get cardHeight() {
    return this.sizeInfo.height;
  }

  get cardWidth() {
    return this.sizeInfo.width;
  }

  imageUrl() {
    return this.asset && this.asset.asset
      ? fullUrlWithRecipe(this.backend, this.asset.asset.image, this.sizeInfo.recipe)
      : null;
  }

  /**
   * @returns {IAssetAction}
   * @private
   */
  _getAction(): IAssetAction {
    if (this.pageProperties.includes(CmsProperty.UseBestSchedule)) {
      const extractor = new ScheduleExtractor(this);
      extractor.extract();
      if (extractor.schedule) {
        return {
          method: this.asset.method,
          type: AssetType.SCHEDULE,
          id: extractor.schedule.id,
          extra: undefined,
        };
      }
    }

    let extra = undefined;
    if (this.asset.method === ActionMethod.FAVOURITE) {
      extra = {
        adult: this.asset.asset.adult,
        pageType: undefined,
      };
    }

    if (this.asset.asset.actionExtra) {
      extra = { ...this.asset.asset.actionExtra };
    }

    return {
      method: this.asset.method,
      type: this.asset.asset.type,
      id: this.asset.asset.id,
      extra: extra,
    };
  }
}
